// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { convertDMStoDD } from 'helpers/coordsConversion'
import { valueAsMeters } from 'helpers/unitConversion'
import { castToFloat } from 'helpers/reduxFormFunctions'

// NOTE - this handles formatting of site data only for Quick Add form.
// This is not called when Path Details is submitted.

// d is the quick add site data

const formatQuickAddSiteForApi = (d, projectDefaultRadioServiceId) => {
  const {
    asr,
    callSign,
    companyId,
  } = d

  const siteName = d.siteName.trim()

  // convert DMS to DD values for API consumption
  const latitude = convertDMStoDD(d.latitude)
  const longitude = convertDMStoDD(d.longitude)

  const elevation = valueAsMeters(d.elevation, d.elevationUnit)

  // hard coded because it's a necessary field which is otherwise handled in path details form.
  // NOTE - segmentStatusId hard coded here as 3 for E: Engineering Proposal
  const segmentStatusId = 3

  // regulatory
  // NOTE - licenseBasisId hard coded here as 1 for Primary
  const licenseBasisId = d.licenseBasisId ? castToFloat(d.licenseBasisId) : 1

  // NOTE - projectDefaultRadioServiceId here will come from getDefaultRadioServiceIdForProject.
  // If there are no paths with radioServiceIds, this thunk will still give us the actual default
  const radioServiceId = d.radioServiceId ? castToFloat(d.radioServiceId) : projectDefaultRadioServiceId

  // NOTE - stationClassId hard coded here as 2 for FXO-Fixed
  const stationClassId = d.stationClassId ? castToFloat(d.stationClassId) : 2

  return {
    asr,
    callSign,
    companyId,
    elevation,
    latitude,
    licenseBasisId,
    longitude,
    radioServiceId,
    segmentStatusId,
    siteName,
    stationClassId,
  }
}

export default formatQuickAddSiteForApi
